const title = "LOIBUS";

export default function getPageTitle(pageTitle) {
    if (pageTitle) {
        return `${pageTitle} - ${title}`;
    }
    return `LOIBUS - 找到你的乐趣`;
}